import { ChatEventType } from '../enums';
export class MessageEvent {
    constructor({ message, conversationId }) {
        this.type = ChatEventType.Message;
        this.message = void 0;
        this.conversationId = void 0;
        this.message = message;
        this.conversationId = conversationId;
    }
}
